'use client';
import styles from './Footer.module.scss';
import { LogoBlue } from '@/public/assets/icons/LogoBlue';
import { IconPhone } from '@/public/assets/icons/IconPhone';
import { IconMail } from '@/public/assets/icons/IconMail';
import { useLocale, useTranslations } from 'next-intl';
import { useState } from 'react';
import { FeedbackForm } from '../FeedbackForm';
import { LogoEng } from '@/public/assets/icons/LogoEng';
import { trackEvent } from '@/shared/components/GoogleMetrika/GoogleMetrika';

const isOnlyEng = process.env.NEXT_PUBLIC_IS_ONLY_EN === 'True';

export const Footer = () => {
  const t = useTranslations('ui.footer');
  const locale = useLocale();
  const Logo = locale === 'en' ? LogoEng : LogoBlue;
  const [isFeedbackOpen, setFeedbackOpen] = useState(false);
  function handleOpenModal(){
    trackEvent('button_click', {
      button_name: 'contact_from_button',
      page: window.location.pathname,
    });
    setFeedbackOpen(true);
  }
  if (isOnlyEng) {
    return (
      <div className={styles.footer}>
        <div className={styles.containerEng}>
          <figure>
            <LogoEng width={108} height={69} />
          </figure>
          <section className={styles.contentWrapperEng}>
            <div className={styles.contentEng}>
              <h6>{t('title')}</h6>
              <h6 className={styles.iSol}>{t('company')}</h6>
              <a
                href={`mailto:${t('mail')}`}
                target="_blank"
                className={styles.mail}
                aria-label={t('aria')}
              >
                <IconMail />
                {t('mail')}
              </a>
            </div>
          </section>
        </div>
        <div className={styles.popup}>
          <div className={styles.popupText}>
            <h6>{t('popup.title')}</h6>
            <p>{t('popup.content')}</p>
          </div>
          <button
            className={styles.popupButton}
            onClick={handleOpenModal}
          >
            {t('popup.connect')}
          </button>
        </div>
        <FeedbackForm
          isOpen={isFeedbackOpen}
          onClose={() => setFeedbackOpen(false)}
        />
      </div>
    );
  }
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <figure>
          <Logo width={108} height={69} />
        </figure>

        <section className={styles.contentWrapper}>
          <div className={styles.content}>
            <h6>{t('title')}</h6>
            <div className={styles.companyWrapper}>
              <span className={styles.ooo}>{t("ooo")}</span>
              <h6 className={styles.iSol}>{t('company')}</h6>
            </div>
            <a href={`tel:${t('phone')}`} target="_blank" className={styles.phone}>
              <IconPhone />
              {t('phone')}
            </a>
            <a
              href={`mailto:${t('mail')}`}
              target="_blank"
              className={styles.mail}
              aria-label={t('aria')}
            >
              <IconMail />
              {t('mail')}
            </a>
          </div>
          <div className={styles.content}>
            <h6>{t('content.first.header')}</h6>
            <a href="/assets/documents/Установка_ПланГР.pdf" target="_blank">
              {t('content.first.documentFirst')}
            </a>
            <a
              href="/assets/documents/ПланГР_Инструкция_пользователя.pdf"
              target="_blank"
            >
              {t('content.first.documentSecond')}
            </a>
            <a
              href="/assets/documents/Сведения_об_эксплуатации_ПланГР_регламент_тех_поддержки.pdf"
              target="_blank"
            >
              {t('content.first.documentThird')}
            </a>
          </div>
          <div className={styles.content}>
            <h6>{t('content.second.header')}</h6>
            <a
              href="/assets/documents/Описание_проекта_ПланГР.pdf"
              target="_blank"
            >
              {t('content.second.documentFirst')}
            </a>
            <a
              href="/assets/documents/Свидетельство_о_гос_регистрации.pdf"
              target="_blank"
            >
              {t('content.second.documentSecond')}
            </a>
            <a href="https://reestr.digital.gov.ru/reestr/8094081/" target="_blank">
              {t('content.second.documentThird')}
            </a>
          </div>
          <div className={styles.content}>
            <h6>{t('content.license.header')}</h6>
            <a
              href="/assets/documents/Оферта_о_заключении_лицензионного_договора.pdf"
              target="_blank"
            >
              {t('content.license.documentFirst')}
            </a>
            <a
              href="/assets/documents/ПЛАН_ГР_Согласие_на_обработку_персональных_данных.pdf"
              target="_blank"
            >
              {t('content.license.documentSecond')}
            </a>
          </div>
        </section>
      </div>

      <div className={styles.popup}>
        <div className={styles.popupText}>
          <h6>{t('popup.title')}</h6>
          <p>{t('popup.content')}</p>
        </div>
        <button
          className={styles.popupButton}
          onClick={handleOpenModal}
        >
          {t('popup.connect')}
        </button>
      </div>
      <FeedbackForm
        isOpen={isFeedbackOpen}
        onClose={() => setFeedbackOpen(false)}
      />
    </footer>
  );
};
